import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button, Badge, Carousel, Modal } from "react-bootstrap";
import Particle from "../Particle";
import HexagonGroup from "../HexagonGroup";
import VideoPlayer from "../VideoPlayer";
import VideoThumbnail from "../VideoThumbnail";
import { getMediaUrl, getBackgroundUrl } from "../../utils/mediaUtils";
import {
  FaMapMarkerAlt,
  FaCalendar,
  FaRuler,
  FaTimes,
  FaPlay,
  FaImage,
  FaChevronLeft,
  FaChevronRight
} from "react-icons/fa";
import { projects as sharedProjects } from "../../data/projects";

// Helper function removed - videos now use direct URLs

// Composant pour la vue plein écran avec zoom
function FullscreenMediaViewer({ project, activeIndex, onClose, onNavigate }) {
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'Escape') {
        onClose();
      } else if (e.key === 'ArrowLeft') {
        const newIndex = activeIndex > 0 ? activeIndex - 1 : project.media.length - 1;
        onNavigate(newIndex);
      } else if (e.key === 'ArrowRight') {
        const newIndex = activeIndex < project.media.length - 1 ? activeIndex + 1 : 0;
        onNavigate(newIndex);
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => document.removeEventListener('keydown', handleKeyPress);
  }, [activeIndex, project.media.length, onClose, onNavigate]);

  if (!project || !project.media || !project.media[activeIndex]) return null;

  const currentMedia = project.media[activeIndex];

  return (
    <div 
      className="fullscreen-viewer"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'zoom-out'
      }}
      onClick={onClose}
    >
      {/* Bouton fermer */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          background: 'rgba(255, 255, 255, 0.2)',
          border: 'none',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          color: 'white',
          fontSize: '1.5em',
          cursor: 'pointer',
          zIndex: 2001,
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.3)';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
        }}
      >
        <FaTimes />
      </button>

      {/* Navigation gauche - Zone clicable minimale */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          const newIndex = activeIndex > 0 ? activeIndex - 1 : project.media.length - 1;
          onNavigate(newIndex);
        }}
          style={{
            position: 'absolute',
            left: '15px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'rgba(255, 255, 255, 0.2)',
            border: 'none',
            borderRadius: '50%',
            width: '40px', // Encore plus petit
            height: '40px', // Encore plus petit
            color: 'white',
            fontSize: '1em',
            cursor: 'pointer',
            zIndex: 500, // Très bas pour ne pas interférer
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0', // Pas de padding pour zone minimale
            margin: '0'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.4)';
            e.target.style.transform = 'translateY(-50%) scale(1.15)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
            e.target.style.transform = 'translateY(-50%) scale(1)';
          }}
        >
          <FaChevronLeft />
        </button>

      {/* Navigation droite - Zone clicable minimale */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          const newIndex = activeIndex < project.media.length - 1 ? activeIndex + 1 : 0;
          onNavigate(newIndex);
        }}
          style={{
            position: 'absolute',
            right: '15px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'rgba(255, 255, 255, 0.2)',
            border: 'none',
            borderRadius: '50%',
            width: '40px', // Encore plus petit
            height: '40px', // Encore plus petit
            color: 'white',
            fontSize: '1em',
            cursor: 'pointer',
            zIndex: 500, // Très bas pour ne pas interférer
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0', // Pas de padding pour zone minimale
            margin: '0'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.4)';
            e.target.style.transform = 'translateY(-50%) scale(1.15)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
            e.target.style.transform = 'translateY(-50%) scale(1)';
          }}
        >
          <FaChevronRight />
        </button>

      {/* Média principal */}
      <div
        onClick={(e) => {
          // Seulement empêcher la propagation si ce n'est pas une vidéo
          if (currentMedia.type !== 'video') {
            e.stopPropagation();
          }
        }}
        style={{
          maxWidth: '90vw',
          maxHeight: '90vh',
          background: currentMedia.type === 'image' ? getBackgroundUrl(currentMedia) : 'transparent',
          borderRadius: '10px',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '60vw',
          minHeight: '60vh',
          cursor: currentMedia.type === 'video' ? 'default' : 'default'
        }}
      >
        {/* Icône type de média */}
        <div style={{
          position: "absolute",
          top: "20px",
          right: "20px",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          color: "white",
          padding: "10px 15px",
          borderRadius: "25px",
          fontSize: "1em"
        }}>
          {currentMedia.type === "video" ? (
            <><FaPlay style={{ marginRight: "8px" }} /> Vidéo</>
          ) : (
            <><FaImage style={{ marginRight: "8px" }} /> Photo</>
          )}
        </div>





        {/* Contenu média */}
        {currentMedia.type === 'video' ? (
          <VideoPlayer
            src={getMediaUrl(currentMedia)}
            style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: '10px' }}
            controls={true}
            autoPlay={false}
            showPlayButton={true}
            context="fullscreen"
          />
        ) : null}
      </div>

      {/* Caption unifié pour images et vidéos - Pass-through */}
      {currentMedia.caption && (
        <div style={{
          position: 'absolute',
          bottom: '40px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          color: 'white',
          padding: '15px 25px',
          borderRadius: '25px',
          fontSize: '1.1em',
          maxWidth: '80vw',
          textAlign: 'center',
          pointerEvents: 'none', // PASS-THROUGH: permet les clics de passer à travers
          zIndex: 100 // Bas pour ne pas interférer
        }}>
          {currentMedia.caption}
        </div>
      )}


    </div>
  );
}

// Composant pour une réalisation individuelle
function RealizationCard({ project, onClick }) {
  return (
    <Col md={6} lg={4} style={{ marginBottom: "30px" }}>
      <Card style={{ 
        height: "100%", 
        backgroundColor: "rgba(245, 241, 232, 0.95)",
        border: "1px solid var(--warm-beige)",
        borderRadius: "15px",
        transition: "all 0.3s ease",
        cursor: "pointer",
        overflow: "hidden"
      }}
      className="realization-card"
      onClick={() => onClick(project)}
      >
        {/* Image/vidéo vignette (1er média si dispo) */}
        <div
          style={{
            height: "200px",
            background: project.media && project.media[0] && project.media[0].type === 'image'
              ? getBackgroundUrl(project.media[0])
              : project.media && project.media[0] && project.media[0].type === 'video'
              ? 'var(--light-beige)'
              : `linear-gradient(135deg, ${project.gradient})`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            overflow: "hidden"
          }}
        >
          {/* Video thumbnail */}
          {project.media && project.media[0] && project.media[0].type === 'video' ? (
            <VideoThumbnail
              src={getMediaUrl(project.media[0])}
              style={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0
              }}
              fallbackGradient={project.gradient}
              showPlayButton={true}
            />
          ) : null}
          
          {/* Fallback icon for projects without media or with non-image first media */}
          {!project.media || !project.media[0] || (project.media[0].type !== 'image' && project.media[0].type !== 'video') ? (
            <div style={{ fontSize: '3em', color: 'rgba(0,0,0,0.3)' }}>{project.icon}</div>
          ) : null}
        </div>
        
        <Card.Body style={{ padding: "25px" }}>
          <div style={{ marginBottom: "15px" }}>
            <Badge
              className="custom-badge"
              style={{
                backgroundColor: "var(--medium-brown) !important",
                color: "white !important",
                fontSize: "0.8em",
                marginBottom: "10px",
                border: "none"
              }}
            >
              {project.category}
            </Badge>
          </div>
          
          <h4 style={{ 
            color: "var(--dark-brown)", 
            marginBottom: "10px",
            fontSize: "1.3em",
            fontWeight: "600"
          }}>
            {project.title}
          </h4>
          
          <p style={{ 
            color: "var(--secondary-text)", 
            fontSize: "0.95em",
            lineHeight: "1.4",
            marginBottom: "15px"
          }}>
            {project.description}
          </p>
          
          <div style={{ 
            display: "flex", 
            justifyContent: "space-between", 
            alignItems: "center",
            fontSize: "0.85em",
            color: "var(--secondary-text)"
          }}>
            <span>
              <FaMapMarkerAlt style={{ marginRight: "5px" }} />
              {project.location}
            </span>
            <span>
              <FaCalendar style={{ marginRight: "5px" }} />
              {project.year}
            </span>
          </div>
          
          {project.surface && (
            <div style={{ 
              marginTop: "10px",
              fontSize: "0.85em",
              color: "var(--secondary-text)"
            }}>
              <FaRuler style={{ marginRight: "5px" }} />
              {project.surface}
            </div>
          )}
        </Card.Body>
      </Card>
    </Col>
  );
}

// Modal de détail avec carousel
function ProjectModal({ project, onClose, onNavigateProject, projectIndex, totalProjects }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  
  // Réinitialiser l'index quand un nouveau projet est sélectionné
  useEffect(() => {
    setActiveIndex(0);
  }, [project]);
  
  if (!project) return null;

  const handleThumbnailClick = (index) => {
    setActiveIndex(index);
  };

  const handleMediaClick = () => {
    setIsFullscreen(true);
  };

  const handleFullscreenClose = () => {
    setIsFullscreen(false);
  };

  const handleFullscreenNavigate = (newIndex) => {
    setActiveIndex(newIndex);
  };

  return (
    <Modal
      show={!!project}
      onHide={onClose}
      size="xl"
      centered
      style={{ zIndex: 1050 }}
    >
      <Modal.Header
        closeButton
        style={{
          backgroundColor: "var(--light-beige)",
          borderBottom: "1px solid var(--warm-beige)",
          position: 'relative'
        }}
      >
        <Modal.Title style={{ color: "var(--dark-brown)", fontSize: "1.8em" }}>
          {project.title}
        </Modal.Title>
        
        {/* Navigation entre projets */}
        {onNavigateProject && (
          <div style={{
            position: 'absolute',
            right: '60px',
            top: '50%',
            transform: 'translateY(-50%)',
            display: 'flex',
            gap: '10px'
          }}>
            {projectIndex > 0 && (
              <button
                onClick={() => onNavigateProject(projectIndex - 1)}
                style={{
                  background: 'var(--medium-brown)',
                  border: 'none',
                  borderRadius: '50%',
                  width: '35px',
                  height: '35px',
                  color: 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'var(--dark-brown)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'var(--medium-brown)';
                }}
                title="Projet précédent"
              >
                <FaChevronLeft />
              </button>
            )}
            
            <span style={{
              color: 'var(--medium-brown)',
              fontSize: '0.9em',
              alignSelf: 'center',
              minWidth: '40px',
              textAlign: 'center'
            }}>
              {projectIndex + 1}/{totalProjects}
            </span>
            
            {projectIndex < totalProjects - 1 && (
              <button
                onClick={() => onNavigateProject(projectIndex + 1)}
                style={{
                  background: 'var(--medium-brown)',
                  border: 'none',
                  borderRadius: '50%',
                  width: '35px',
                  height: '35px',
                  color: 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'var(--dark-brown)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'var(--medium-brown)';
                }}
                title="Projet suivant"
              >
                <FaChevronRight />
              </button>
            )}
          </div>
        )}
      </Modal.Header>

      <Modal.Body style={{ backgroundColor: "var(--light-beige)", padding: "0" }}>
        <Row style={{ margin: "0" }}>
          {/* Carousel Section */}
          <Col md={7} style={{ padding: "0" }}>
            {project.media && project.media.length > 0 && (
              <div>
                <Carousel
                  activeIndex={activeIndex}
                  onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}
                  interval={null}
                  indicators={false}
                  controls={true}
                  style={{ borderRadius: "0" }}
                >
                  {project.media.map((media, index) => (
                    <Carousel.Item key={index}>
                      <div 
                        style={{
                          height: "400px",
                          background: media.type === 'image' ? media.url : 'var(--light-beige)',
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "relative",
                          cursor: "zoom-in"
                        }}
                        onClick={handleMediaClick}
                      >
                        {/* Icône pour différencier image/vidéo */}
                        <div style={{
                          position: "absolute",
                          top: "20px",
                          right: "20px",
                          backgroundColor: "rgba(0, 0, 0, 0.6)",
                          color: "white",
                          padding: "8px 12px",
                          borderRadius: "20px",
                          fontSize: "0.9em"
                        }}>
                          {media.type === "video" ? (
                            <><FaPlay style={{ marginRight: "5px" }} /> Vidéo</>
                          ) : (
                            <><FaImage style={{ marginRight: "5px" }} /> Photo</>
                          )}
                        </div>

                        {/* Media content */}
                        {media.type === "video" ? (
                          <VideoPlayer
                            src={getMediaUrl(media)}
                            style={{ 
                              width: "100%", 
                              height: "400px", 
                              objectFit: "cover",
                              borderRadius: "10px" 
                            }}
                            controls={true}
                            preload="metadata"
                            onClick={(e) => e.stopPropagation()}
                            showPlayButton={true}
                            context="carousel"
                          />
                        ) : (
                          // For images, we keep CSS background already set via media.url
                          <div
                            aria-hidden
                            style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}
                          />
                        )}
                      </div>
                      {/* Caption unifié pour images et vidéos */}
                      {media.caption && (
                        <Carousel.Caption style={{
                          backgroundColor: "rgba(0, 0, 0, 0.3)",
                          borderRadius: "10px",
                          padding: "10px 15px"
                        }}>
                          <p style={{ margin: "0", fontSize: "1em" }}>{media.caption}</p>
                        </Carousel.Caption>
                      )}
                    </Carousel.Item>
                  ))}
                </Carousel>
                
                {/* Galerie de miniatures */}
                {project.media.length > 1 && (
                  <div style={{
                    padding: "15px",
                    backgroundColor: "rgba(245, 241, 232, 0.8)",
                    borderTop: "1px solid var(--warm-beige)"
                  }}>
                    <div style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      flexWrap: "wrap"
                    }}>
                      {project.media.map((media, index) => (
                        <div
                          key={index}
                          onClick={() => handleThumbnailClick(index)}
                          style={{
                            width: "60px",
                            height: "60px",
                            background: media.type === 'image' ? media.url : 'var(--light-beige)',
                            borderRadius: "8px",
                            cursor: "pointer",
                            border: activeIndex === index ? "3px solid var(--medium-brown)" : "2px solid rgba(255, 255, 255, 0.5)",
                            transition: "all 0.3s ease",
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            opacity: activeIndex === index ? 1 : 0.7,
                            overflow: "hidden"
                          }}
                          onMouseEnter={(e) => {
                            if (activeIndex !== index) {
                              e.target.style.opacity = "0.9";
                              e.target.style.transform = "scale(1.05)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (activeIndex !== index) {
                              e.target.style.opacity = "0.7";
                              e.target.style.transform = "scale(1)";
                            }
                          }}
                        >
                          {/* Video thumbnail */}
                          {media.type === 'video' && (
                            <video
                              src={media.url}
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                position: 'absolute',
                                top: 0,
                                left: 0
                              }}
                              muted
                              preload="metadata"
                            />
                          )}
                          
                          {/* Icône type de média sur la miniature */}
                          <div style={{
                            position: "absolute",
                            top: "2px",
                            right: "2px",
                            backgroundColor: "rgba(0, 0, 0, 0.8)",
                            color: "white",
                            padding: "2px 4px",
                            borderRadius: "4px",
                            fontSize: "0.6em",
                            zIndex: 2
                          }}>
                            {media.type === "video" ? <FaPlay /> : <FaImage />}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </Col>

          {/* Details Section */}
          <Col md={5} style={{ padding: "30px" }}>
            <div style={{ marginBottom: "25px" }}>
              <Badge
                className="custom-badge"
                style={{
                  backgroundColor: "var(--medium-brown) !important",
                  color: "white !important",
                  fontSize: "0.9em",
                  marginBottom: "15px",
                  border: "none"
                }}
              >
                {project.category}
              </Badge>

              <div style={{ marginBottom: "20px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                  <span style={{ color: "var(--secondary-text)" }}>
                    <FaMapMarkerAlt style={{ marginRight: "8px", color: "var(--medium-brown)" }} />
                    {project.location}
                  </span>
                  <span style={{ color: "var(--secondary-text)" }}>
                    <FaCalendar style={{ marginRight: "8px", color: "var(--medium-brown)" }} />
                    {project.year}
                  </span>
                </div>
                {project.surface && (
                  <div style={{ color: "var(--secondary-text)" }}>
                    <FaRuler style={{ marginRight: "8px", color: "var(--medium-brown)" }} />
                    {project.surface}
                  </div>
                )}
              </div>
            </div>

            <div style={{ marginBottom: "25px" }}>
              <h5 style={{ color: "var(--dark-brown)", marginBottom: "15px" }}>Description</h5>
              <p style={{
                color: "var(--secondary-text)",
                lineHeight: "1.6",
                fontSize: "1em",
                whiteSpace: "pre-line"
              }}>
                {project.fullDescription}
              </p>
            </div>

            {project.details && (
              <div>
                <h5 style={{ color: "var(--dark-brown)", marginBottom: "15px" }}>Détails du projet</h5>

                <div style={{ marginBottom: "15px" }}>
                  <strong style={{ color: "var(--medium-brown)" }}>Client :</strong>
                  <span style={{ color: "var(--secondary-text)", marginLeft: "10px" }}>
                    {project.details.client}
                  </span>
                </div>

                <div style={{ marginBottom: "15px" }}>
                  <strong style={{ color: "var(--medium-brown)" }}>Budget travaux :</strong>
                  <span style={{ color: "var(--secondary-text)", marginLeft: "10px" }}>
                    {project.details.budget}
                  </span>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer style={{
        backgroundColor: "var(--light-beige)",
        borderTop: "1px solid var(--warm-beige)",
        justifyContent: "center"
      }}>
        <Button
          onClick={onClose}
          style={{
            backgroundColor: "var(--medium-brown)",
            border: "none",
            padding: "10px 30px",
            borderRadius: "25px",
            fontSize: "1.1em"
          }}
        >
          <FaTimes style={{ marginRight: "8px" }} />
          Fermer
        </Button>
      </Modal.Footer>
      
      {/* Vue plein écran */}
      {isFullscreen && (
        <FullscreenMediaViewer
          project={project}
          activeIndex={activeIndex}
          onClose={handleFullscreenClose}
          onNavigate={handleFullscreenNavigate}
        />
      )}
    </Modal>
  );
}

function Realizations() {
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedProjectIndex, setSelectedProjectIndex] = useState(0);
  const [filter, setFilter] = useState("Tous");

  // Use shared centralized dataset
  const projects = sharedProjects;

  // Catégories dynamiques à partir des projets
  const categories = React.useMemo(() => {
    const set = new Set(["Tous"]);
    (projects || []).forEach(p => {
      if (p.category && typeof p.category === 'string') set.add(p.category);
    });
    return Array.from(set);
  }, [projects]);

  const filteredProjects = filter === "Tous"
    ? projects
    : projects.filter(project => project.category === filter);

  // Fonctions de navigation entre projets
  const handleProjectSelect = (project) => {
    const projectIndex = filteredProjects.findIndex(p => p.id === project.id);
    setSelectedProject(project);
    setSelectedProjectIndex(projectIndex);
  };

  const handleProjectNavigation = (newIndex) => {
    if (newIndex >= 0 && newIndex < filteredProjects.length) {
      setSelectedProject(filteredProjects[newIndex]);
      setSelectedProjectIndex(newIndex);
    }
  };

  return (
    <Container fluid className="realizations-section">
      <Particle />
      <Container>
        {/* Header Section */}
        <Row style={{ justifyContent: "center", paddingBottom: "30px" }}>
          <Col md={12} style={{ textAlign: "center" }}>
            <h1 style={{ 
              fontSize: "2.5em", 
              paddingBottom: "20px",
              color: "var(--primary-text)"
            }}>
              <strong className="purple">Réalisations</strong>
            </h1>
            <p style={{ 
              fontSize: "1.2em", 
              color: "var(--secondary-text)",
              maxWidth: "800px",
              margin: "0 auto 30px auto",
              lineHeight: "1.6"
            }}>
              Découvrez une sélection de mes projets récents, de l'aménagement résidentiel 
              à la scénographie, en passant par les espaces commerciaux.
            </p>
            {/* Hexagones décoratifs après le titre */}
            <HexagonGroup position="center" />
          </Col>
        </Row>

        {/* Filter Buttons */}
        <Row style={{ justifyContent: "center", marginBottom: "40px" }}>
          <Col md={12} style={{ textAlign: "center" }}>
            {categories.map((category) => (
              <Button
                key={category}
                onClick={() => setFilter(category)}
                style={{
                  backgroundColor: filter === category ? "var(--medium-brown)" : "transparent",
                  color: filter === category ? "white" : "var(--medium-brown)",
                  border: `2px solid var(--medium-brown)`,
                  borderRadius: "25px",
                  margin: "5px",
                  padding: "8px 20px",
                  fontWeight: "600",
                  transition: "all 0.3s ease"
                }}
                className="filter-btn"
              >
                {category}
              </Button>
            ))}
          </Col>
        </Row>

        {/* Hexagones décoratifs avant la grille de projets */}
        <HexagonGroup position="right" />

        {/* Projects Grid */}
        <Row style={{ justifyContent: "center" }}>
          {filteredProjects.map((project) => (
            <RealizationCard
              key={project.id}
              project={project}
              onClick={handleProjectSelect}
            />
          ))}
        </Row>

        {/* Hexagones décoratifs avant les statistiques */}
        <HexagonGroup position="scattered" />

        {/* Stats Section */}
        <Row style={{ justifyContent: "center", paddingTop: "50px" }}>
          <Col md={10}>
            <div style={{ 
              backgroundColor: "rgba(139, 115, 85, 0.1)",
              padding: "40px",
              borderRadius: "20px",
              textAlign: "center"
            }}>
              <Row>
                <Col md={3} sm={6} style={{ marginBottom: "20px" }}>
                  <h3 style={{ color: "var(--medium-brown)", fontSize: "2.5em" }}>25+</h3>
                  <p style={{ color: "var(--secondary-text)" }}>Projets réalisés</p>
                </Col>
                <Col md={3} sm={6} style={{ marginBottom: "20px" }}>
                  <h3 style={{ color: "var(--medium-brown)", fontSize: "2.5em" }}>100%</h3>
                  <p style={{ color: "var(--secondary-text)" }}>Clients satisfaits</p>
                </Col>
                <Col md={3} sm={6} style={{ marginBottom: "20px" }}>
                  <h3 style={{ color: "var(--medium-brown)", fontSize: "2.5em" }}>3</h3>
                  <p style={{ color: "var(--secondary-text)" }}>Années d'expérience</p>
                </Col>
                <Col md={3} sm={6} style={{ marginBottom: "20px" }}>
                  <h3 style={{ color: "var(--medium-brown)", fontSize: "2.5em" }}>4</h3>
                  <p style={{ color: "var(--secondary-text)" }}>Domaines d'expertise</p>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
      
      {/* Modal */}
      <ProjectModal 
        project={selectedProject} 
        onClose={() => setSelectedProject(null)}
        onNavigateProject={handleProjectNavigation}
        projectIndex={selectedProjectIndex}
        totalProjects={filteredProjects.length}
      />
    </Container>
  );
}

export default Realizations;
